module.exports = "<p>\n  rabatt works!\n</p>\n"